import CmpDiagnostics from "./CmpDiagnostics";

export default CmpDiagnostics;